import React, { Component } from "react";
import { getCompFuncByString, getMessageTime, profilePicValidityCheck } from "../../utils/constants";
import DaniIcon from "./../../assets/dani_icon.svg";
import UserIcon from "./../../assets/user-image-plc/User_Cat.svg";
import GoBackComponent from "./GoBackComponent";

class DaniTextStep extends Component {
  componentDidMount() {
    // console.log("mounted");
    console.log("first",this.props.actionTaken)
    if(this.props.step.id=="9" && !this.props.actionTaken){
      console.log("inside--------first",this.props.actionTaken)
      this.props.actionTakenOn()
    }else{
      this.props.triggerNextStep(this.props.step);
    }

  }

  replaceName = message => {
    if (!message) {
      return;
    }
    const { loggedInUser } = this.props;
    if (message.indexOf("_$USER_NAME$_") >= 0) {
      message= message.replace("_$USER_NAME$_", loggedInUser.firstName);
    }
    if (message.indexOf("_$DANI_NAME$_") >= 0) {
      message= message.replace("_$DANI_NAME$_", 'Dani');
    }
    return message;
  };

  createMarkup = input => {
    input = this.replaceName(input);
    return { __html: `<div>${input}  </div>` };
  };

  render() {
    // console.log('txt Step --- ', this.props)
    const { isLast, step, user } = this.props;
    let ModalComp;
    if (step.clickModalComponent) {
      ModalComp = getCompFuncByString(step.clickModalComponent);
    }

    let imgIcon=DaniIcon

    if(this.props.freeDaniImg){
      imgIcon=this.props.freeDaniImg
    }

    return (
      <div>
        {step.user ? (
          <div className="dani-user-step-container">
            <div className="dani-user-step">{this.props.step.message}</div>
            <img
              className="dani-chat-profile-icon"
              src={profilePicValidityCheck(this.props.userPic) ? this.props.userPic : UserIcon}
            />
          </div>
        ) : (
          <div className="dani-step-container">
            <img
              className="dani-chat-profile-icon"
              // style={{
              //   display: isLast ? "initial" : "none",
              //   marginBottom: "10px",
              //   width: "30px",
              //   marginLeft: "15px",
              // }}
              src={imgIcon}
            />
            <div
              className="dani-step"
              style={{
                marginLeft: isLast ? "3px" : "3px",
                marginBottom: isLast ? "0px" : "2px",
                padding: "14px 1.2rem",
              }}
            >
              <span
                dangerouslySetInnerHTML={this.createMarkup(
                  this.props.step.message
                )}
              ></span>
              <span>
                {this.props.step.clickModalComponent ? <ModalComp /> : ""}
              </span>
            </div>
          </div>
        )}

        {step.timeStamp && (
          <div
            className={
              step.user
                ? "user-message-timestamp-text"
                : "message-timestamp-text"
            }
          >
            {getMessageTime(step.timeStamp)}
          </div>
        )}
      </div>
    );
  }
}

export default DaniTextStep;
